import { isStandalone } from '@/features/install/platform';

/**
 * הקישור בהודעת ברוכים הבאים הוא app.url?invite=1 (PRD 5.16).
 * כשהוא נפתח בדפדפן ולא מתוך אפליקציה מותקנת, מפנים למסך ההתקנה.
 * נקרא פעם אחת לפני עליית הראוטר, כדי שזה יקרה גם לפני מסך הכניסה.
 */
export function applyInviteRedirect() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('invite') !== '1') return;
  if (isStandalone()) return;
  if (window.location.pathname === '/install') return;

  window.history.replaceState(null, '', '/install');
}
